import { render, staticRenderFns } from "./CoursesMian.vue?vue&type=template&id=3a6aefeb&scoped=true"
import script from "./CoursesMian.vue?vue&type=script&lang=js"
export * from "./CoursesMian.vue?vue&type=script&lang=js"
import style0 from "./CoursesMian.vue?vue&type=style&index=0&id=3a6aefeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6aefeb",
  null
  
)

export default component.exports